const unitsRecalcDefaults = {
  loading: false,
  hadFieldSelected: false,
  hadFarmingUnitSelected: false,
};

const unitsRecalcReducer = (state = unitsRecalcDefaults, action) => {
  switch (action.type) {
    case 'START_UNITS_RECALC':
      return {
        loading: true,
        hadFieldSelected: action.hadFieldSelected,
        hadFarmingUnitSelected: action.hadFarmingUnitSelected,
      };
    case 'STOP_UNITS_RECALC':
      return {
        ...unitsRecalcDefaults,
      };
    default:
      return state;
  }
};

module.exports = {
  unitsRecalcDefaults,
  unitsRecalcReducer,
};
